import {connect} from 'react-redux';
import Page from '../../app/components/Page';
import React, {Component} from 'react';
import {FormComponent} from './ConfirmForm';
import Alert from '../../../ui/Alert';
import {FormattedMessage} from 'react-intl';
import {createSubmitAction} from '../../app/forms';
import {GET_SOFT_DELETE, GET_SOFT_DELETE_FAILURE, GET_SOFT_DELETE_SUCCESS} from '../settings';
import Button from '../../../ui/Button';
import styles from './css/DeactivateProfile.scss';

export class ConfirmDeactivation extends Component {

    constructor(...args) {
        super(...args);
        this.state = {
            userConfirm: false,
            success: false,
            erroneous: false,
            errors: [],
        };
    }

    componentWillMount() {
        window.scrollTo(0, 0);
    }

    handleUserConfirm = () => {
        this.setState({
            userConfirm: true,
        })
    }

    handleSubmitFailure = () => {
        this.setState({
            erroneous: true,
        });
    };

    handleSubmitSuccess = () => {
        const {settings} = this.props;
        if (settings.get('deleted') && !settings.get('emailMismatch')) {
            this.setState({success: true});
            // TODO redirect to logout route once implemented
            setTimeout(() => {
                window.location.reload();
            }, 4000)
        }
    }

    render() {
        const {erroneous, userConfirm, success} = this.state;
        const {settings, session} = this.props;

        const userId = session.getIn(['user', 'id']);

        return (
            <Page.Body>
                <Page.Section depth={0}>
                    <h2>
                        <FormattedMessage id='frontend.form_deactivate.headline'/>
                    </h2>
                </Page.Section>
                <Page.Section>
                    <div className={styles.wrap}>
                        {userConfirm && !success && <div>
                            {erroneous && settings.get('error') && (
                                <Alert key='danger' type='danger'>
                                    {settings.get('error')}
                                </Alert>)}
                            {erroneous && settings.get('emailMismatch') && (
                                <Alert key='danger' type='danger'>
                                    <FormattedMessage id={'frontend.form_deactivate.message.email_mismatch'}/>
                                </Alert>)}
                            <FormComponent
                                userId={userId}
                                onSubmitFail={this.handleSubmitFailure}
                                onSubmitSuccess={this.handleSubmitSuccess}
                                onSubmit={createSubmitAction(GET_SOFT_DELETE, GET_SOFT_DELETE_SUCCESS, GET_SOFT_DELETE_FAILURE)}
                            />
                        </div>}
                        {!userConfirm && !success && <div className={styles.buttonField}>
                            <Alert key='deactivateProfile' type='deactivateProfile'>
                                <i className='fa fa-exclamation-triangle'></i>
                                <FormattedMessage
                                    id='frontend.form_deactivate.text.deactivate_warning'
                                />
                            </Alert>
                            <div className={styles.buttonField}>
                                <Button emphasis='primary' type='submit' onClick={this.handleUserConfirm}>
                                    <FormattedMessage id='frontend.form_deactivate.button.yes'/>
                                </Button>
                                <Button link to='/settings' emphasis='default' type='submit'>
                                    <FormattedMessage id='frontend.form_deactivate.button.no'/>
                                </Button>
                            </div>
                        </div>}
                        {success && <div>
                            <Alert key='success' type='success'>
                                <FormattedMessage
                                    id='frontend.form_deactivate.text.deactivate_success'
                                />
                            </Alert>
                        </div>}
                    </div>
                </Page.Section>
            </Page.Body>
        );
    }
}

export default connect(state => ({
    session: state.session,
    settings: state.settings,
}))(ConfirmDeactivation);
